import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const ComponentArea: any = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 42px;
  min-height: 540px;
`;

export const HeaderArea: any = styled.div`
  position: absolute;
  background-size: cover;
  top: 0;
  height: 150px;
  background-image: url('/images/onboarding/oval-invert.svg');
  width: 100%;
  background-position: bottom;
  background-repeat: no-repeat;
`;

ComponentArea.Next = styled.div`
  position: absolute;
  right: 0;
  left: 50%;
  top: 0;
  bottom: 0;
  background-color: ${ColorPalette.Transparent};
  cursor: pointer;
`;

ComponentArea.Previous = styled.div`
  position: absolute;
  left: 0;
  right: 50%;
  top: 0;
  bottom: 0;
  background-color: ${ColorPalette.Transparent};
`;

export const StepsArea = styled.div`
  margin-bottom: 16px;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  padding: 0px 40px;
`;

export const Steps = styled.ul`
  display: flex;
`;

interface CircleStyledProps {
  styledProps: {
    active: boolean;
  };
}

export const Circle = styled.li.attrs<HTMLLIElement>((): any => {})<CircleStyledProps>`
  width: 8px;
  height: 8px;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 13px;
  background: ${({ styledProps, theme }) =>
    styledProps.active ? theme.stepper.activeBackground : theme.stepper.background};

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const Next = styled.div`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  width: 100%;
  padding: 0px 16px 32px 16px;
`;
